<template>
	<div class="m-operate">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'mOperate'
	}
</script>

<style lang="stylus" scoped>
	.m-operate {
		padding: 0 20px;
		line-height: 50px;
		
		> .c-button:nth-child(n+2) {
			margin-left: 10px;
		}
	}
</style>
